export default __webpack_public_path__ + "static/media/Jemmity_text.7a96c10f.png";